import { TextBolder } from '@phosphor-icons/react';

export default TextBolder;
